import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import WorkoutOfTheDay from "../pages/company/WorkoutOfTheDay";
import TransformationWorkoutOfTheDay from "../pages/company/TransformationWorkoutOfTheDay";
import Register from "../pages/verifyuser/VerifyUser";
import { Box, Divider } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import AppHeader from "../components/UserHeader";
import { Drawer } from "./Drawer";
import Dashboard from "../pages/company/Dashboard";
import Exercises from "../pages/company/Exercises";
import Content from "../pages/content/Content";
import Members from "../pages/members/Members";
import Leads from "../pages/leads/Leads";
import Subscription from "../pages/subscription/Subscription";
import Dietplans from "../pages/dietplans/Dietplans";
import ContentManagement from "../pages/contentmanagement/Contentmangement";
import SentFreebie from "../pages/sentfreebie/SentFreebie";
import SubscriptionsOrders from "../pages/subscriptions-orders/SubscriptionsOrders";
import {
  AdminFeatureKey,
  getFirstEnabledAdminPath,
  isAdminFeatureEnabled,
} from "../config/adminFeatures";

const NoEnabledFeatures = () => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: 3,
    }}
  >
    No admin features are enabled for this deployment.
  </Box>
);

const Navigation = () => {
  const { isAuthenticated } = useAuth();
  const firstEnabledPath = getFirstEnabledAdminPath();

  const renderFeatureRoute = (
    featureKey: AdminFeatureKey,
    element: JSX.Element
  ): JSX.Element => {
    if (isAdminFeatureEnabled(featureKey)) {
      return element;
    }

    if (firstEnabledPath) {
      return <Navigate to={firstEnabledPath} replace />;
    }

    return <NoEnabledFeatures />;
  };

  const renderFallbackRoute = (): JSX.Element => {
    if (firstEnabledPath) {
      return <Navigate to={firstEnabledPath} replace />;
    }

    return <NoEnabledFeatures />;
  };

  return (
    <BrowserRouter>
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {isAuthenticated && <AppHeader />}
        <Box
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            overflow: "hidden",
          }}
        >
          {isAuthenticated && <Drawer />}
          <Divider />
          <Box style={{ flex: 1, overflow: "hidden" }}>
            <Routes>
              <Route
                path="/"
                element={renderFeatureRoute("dashboard", <Dashboard />)}
              />
              <Route path="verify" element={<Register />} />
              <Route
                path="exercise"
                element={renderFeatureRoute("exercises", <Exercises />)}
              />
              <Route
                path="wod"
                element={renderFeatureRoute("wod", <WorkoutOfTheDay />)}
              />
              <Route
                path="transformation-wod"
                element={renderFeatureRoute(
                  "transformation_wod",
                  <TransformationWorkoutOfTheDay />
                )}
              />
              <Route
                path="members"
                element={renderFeatureRoute("members", <Members />)}
              />
              <Route
                path="leads"
                element={renderFeatureRoute("leads", <Leads />)}
              />
              <Route
                path="content"
                element={renderFeatureRoute("content", <Content />)}
              />
              <Route
                path="programs"
                element={renderFeatureRoute("programs", <Subscription />)}
              />
              <Route
                path="dietplans"
                element={renderFeatureRoute("dietplans", <Dietplans />)}
              />
              <Route path="sentfreebie" element={<SentFreebie />} />
              <Route
                path="subscriptions-orders"
                element={renderFeatureRoute(
                  "subscriptions_orders",
                  <SubscriptionsOrders />
                )}
              />

              <Route
                path="content-management"
                element={renderFeatureRoute(
                  "content_management",
                  <ContentManagement />
                )}
              />
              <Route path="*" element={renderFallbackRoute()} />
            </Routes>
          </Box>
        </Box>
      </Box>
    </BrowserRouter>
  );
};

export default Navigation;
